import { Controller } from "stimulus";

export default class extends Controller {
  static values = {id: String,modalityId: String, childModalityId: String}

  toggleActive(event) {
    const selectedValue = event.target.value;
    const modalityId = this.modalityIdValue;
    const childModalityId = this.childModalityIdValue; 
    fetch("/update_child_modality_visibility", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: childModalityId,
        modality_id: modalityId,
        child_modality_id: childModalityId,
        is_active: selectedValue === "true"
      })
    })
  }
}
